import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="container py-4">
      <div className="row text text-center pt-5 pb-15">
        {/* <div className="tp-footer-2__logo"> */}
        <Link to={"home"}>
          <img src="assets/img/logo/logo.png" alt="" style={{height:"auto", width:"150px"}} />
        </Link>
        {/* </div> */}
        <h4 className="text-left second mt-20">Privacy Policy</h4>
      </div>

      <div className="row pb-5">
        <div className="col-12 text-left">
          <p className="text-muted mb-4">Last updated: July 8, 2026</p>

          <p>
            At printlific, we value your trust and are committed to protecting
            your personal information. This Privacy Policy explains how we
            collect, use, and safeguard your information when you visit our
            website, upload photos, and place orders for custom canvas prints
            and related products.
          </p>

          <h5 className="fw-bold mt-4 mb-3">1. Information We Collect</h5>
          <p>We collect the following types of information:</p>
          <ul>
            <li>
              <strong>Account Information:</strong> Name, email address, phone
              number, and password when you create an account.
            </li>
            <li>
              <strong>Shipping &amp; Billing Information:</strong> Address,
              city, state, country, and postal code for order fulfillment and
              invoicing.
            </li>
            <li>
              <strong>Payment Information:</strong> Payment details are
              processed securely through our third-party payment processor. We
              do not store your full card details on our servers.
            </li>
            <li>
              <strong>Uploaded Photos &amp; Images:</strong> The images you
              upload to create your custom canvas prints, gallery wraps, or
              other products.
            </li>
            <li>
              <strong>Order History:</strong> Details of products you've
              purchased, order status, and tracking information.
            </li>
            <li>
              <strong>Device &amp; Usage Data:</strong> IP address, browser
              type, pages visited, and cookies used to improve your experience
              on our site.
            </li>
          </ul>

          <h5 className="fw-bold mt-4 mb-3">2. How We Use Your Photos</h5>
          <p>
            Photos you upload are used solely for the purpose of producing your
            ordered canvas prints and related products. We do not sell, share,
            or use your uploaded images for marketing purposes without your
            explicit consent. Uploaded images are retained for a limited period
            after order completion to support reprints and customer service,
            after which they may be deleted from our active systems.
          </p>

          <h5 className="fw-bold mt-4 mb-3">3. How We Use Your Information</h5>
          <p>We use the information we collect to:</p>
          <ul>
            <li>
              Process and fulfill your orders, including printing and shipping
            </li>
            <li>
              Communicate order confirmations, shipping updates, and delivery
              notifications
            </li>
            <li>Provide customer support and respond to inquiries</li>
            <li>
              Improve our website, products, and overall shopping experience
            </li>
            <li>
              Send promotional offers and updates, where you have opted in
            </li>
            <li>Detect and prevent fraud or unauthorized activity</li>
          </ul>

          <h5 className="fw-bold mt-4 mb-3">4. Sharing Your Information</h5>
          <p>
            We do not sell your personal information. We may share your
            information with trusted third parties strictly for the purposes of
            operating our business, including:
          </p>
          <ul>
            <li>
              <strong>Shipping Carriers:</strong> To deliver your orders and
              provide tracking updates.
            </li>
            <li>
              <strong>Payment Processors:</strong> To securely process
              transactions.
            </li>
            <li>
              <strong>Printing &amp; Fulfillment Partners:</strong> To produce
              your custom canvas products.
            </li>
            <li>
              <strong>Analytics Providers:</strong> To help us understand site
              usage and improve performance.
            </li>
          </ul>

          <h5 className="fw-bold mt-4 mb-3">
            5. Cookies &amp; Tracking Technologies
          </h5>
          <p>
            We use cookies and similar technologies to remember your
            preferences, keep items in your cart, and analyze site traffic. You
            can control cookie preferences through your browser settings, though
            disabling cookies may affect certain site features.
          </p>

          <h5 className="fw-bold mt-4 mb-3">6. Data Security</h5>
          <p>
            We implement industry-standard security measures, including
            encryption and secure servers, to protect your personal information
            and uploaded photos from unauthorized access, loss, or misuse.
            However, no method of transmission over the internet is completely
            secure, and we cannot guarantee absolute security.
          </p>

          <h5 className="fw-bold mt-4 mb-3">7. Your Rights &amp; Choices</h5>
          <p>You have the right to:</p>
          <ul>
            <li>Access, update, or delete your account information</li>
            <li>Request deletion of uploaded photos after order completion</li>
            <li>Opt out of marketing emails at any time</li>
            <li>Request a copy of the personal data we hold about you</li>
          </ul>
          <p>
            To exercise any of these rights, please contact us using the details
            below.
          </p>

          <h5 className="fw-bold mt-4 mb-3">8. Children's Privacy</h5>
          <p>
            Our services are not directed to individuals under the age of 13. We
            do not knowingly collect personal information from children. If you
            believe we have inadvertently collected such information, please
            contact us so we can remove it.
          </p>

          <h5 className="fw-bold mt-4 mb-3">9. Changes to This Policy</h5>
          <p>
            We may update this Privacy Policy from time to time to reflect
            changes in our practices or for legal, operational, or regulatory
            reasons. We will post the updated policy on this page with a revised
            "Last updated" date.
          </p>

          <h5 className="fw-bold mt-4 mb-3">10. Contact Us</h5>
          <p>
            If you have any questions or concerns about this Privacy Policy or
            how your information is handled, please contact us at:
          </p>
          <p>
            Email: <a href="mailto:info@Printlific.com">info@Printlific.com</a>
            <br />
            Contact: +1 (917) 386-4948
          </p>
        </div>
      </div>
    </div>
  );
}
